import React from 'react'
import cx from 'classnames'

import Modal from 'components/shared/Modal'

import style from './style.styl'

const DriftModal = ({
  onRequestClose,
  onSecondaryClick,
  onPrimaryClick,
  isDanger,
  title,
  children,
  primaryCTA,
  secondaryCTA,
  hidePrimary,
  ...modalProps,
}) => (
  <Modal
    style={{
      content: {
        padding: 0,
        backgroundColor: 'transparent',
        border: 'none',
      }
    }}
    onRequestClose={onRequestClose}
    {...modalProps}
  >
    <div className={cx(style.DriftModal, 'dsg-card', { 'hide-primary': hidePrimary })}>
      <div className="content">
        <h3 className="dsg-h3">{title}</h3>
        <p className="dsg-Body color-navy-extra-dark">{children}</p>
      </div>
      <div className="actions">
        <button
          onClick={onSecondaryClick}
          className="drift-button large"
        >
          {secondaryCTA}
        </button>
        {!hidePrimary &&
          <button
            onClick={onPrimaryClick}
            className={cx(
              'drift-button',
              'large',
              {
                'drift-button-danger': isDanger,
                'drift-button-primary': !isDanger,
              }
            )}
          >
            {primaryCTA}
          </button>
        }
      </div>
    </div>
  </Modal>
)

export default DriftModal



// WEBPACK FOOTER //
// ./src/scripts/components/shared/DriftModal/index.js